import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { InboxListStateType, InboxResponseItem, MessageViewStatus, Pagination } from 'src/shared/types/src';

const initialState: InboxListStateType = {
  loading: true,
  paginatedLoading: false,
  inbox: [],
  pagination: {
    currentPage: 1,
    from: 1,
    itemsPerPage: 0,
    lastPage: 1,
    to: 1,
    totalItems: 1,
  },
  deletingMessageIds: []
};

const inboxSlice = createSlice({
  name: 'inboxSlice',
  initialState,
  reducers: {
    setInboxLoader: (state, action: PayloadAction<{ loading: boolean }>) => {
      state.loading = action.payload.loading;
    },
    setInboxPaginatedLoader: (
      state,
      action: PayloadAction<{ paginatedLoading: boolean }>
    ) => {
      state.paginatedLoading = action.payload.paginatedLoading;
    },
    appendInbox: (
      state,
      action: PayloadAction<{
        list: InboxResponseItem[];
        pagination: Pagination;
      }>
    ) => {
      state.pagination = action.payload.pagination;
      state.inbox.push(...action.payload.list);
    },
    resetInboxState: () => {
      return {
        ...initialState,
      };
    },
    updateReadStatus: (state, action: PayloadAction<{ id: number }>) => {
      const inboxList = state.inbox;
      const inboxIdx = state.inbox.findIndex(
        (obj) => obj.id === action.payload.id
      );
      if (inboxIdx === -1) {
        return;
      }
      const self: MessageViewStatus = {
        ...inboxList[inboxIdx].self,
        isViewed: true
      }
      const updatedObj: InboxResponseItem = {
        ...inboxList[inboxIdx],
        self: self,
      };
      state.inbox = [
        ...inboxList.slice(0, inboxIdx),
        updatedObj,
        ...inboxList.slice(inboxIdx + 1),
      ];
    },
    updateDeleteMessageId: (state, action: PayloadAction<{ messageId: string }>) => {
      const messageIds = state.deletingMessageIds;
      const id = action.payload.messageId;
      if (!messageIds.includes(id)) {
        state.deletingMessageIds.push(id);
      } else {
        state.deletingMessageIds = messageIds.filter((x) => x !== id);
      }
    },
    removeInboxMessage: (state, action: PayloadAction<{ messageId: string }>) => {
      const messages = state.inbox;
      state.inbox = messages.filter((x) => String(x.id) !== action.payload.messageId);
    }
  },
});

export const InboxActions = inboxSlice.actions;
export default inboxSlice.reducer;
